var map = {
	"./left_01.png": "6f2c",
	"./left_02.png": "b310",
	"./left_03.png": "149b",
	"./left_04.png": "e292",
	"./left_05.png": "8f58",
	"./left_06.png": "6599",
	"./left_07.png": "689e",
	"./left_08.png": "bc65",
	"./left_09.png": "a73b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9cb6";